var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 80,
    viewBox: "0 0 132 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-data"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background-complete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.3648 11.0007L4.78223 27.25L28.9959 63.0185L53.5784 46.7691L29.3648 11.0007Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.8714 45.0746L40.5931 46.7806L28.3721 45.04L28.6503 43.334L40.8714 45.0746Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.7161 38.9912L36.4688 39.2402L34.5255 51.1303L32.7705 50.8791L34.7161 38.9912Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.4718 23.8773C23.4893 23.9011 21.0267 25.5616 17.9704 27.5794C14.914 29.5972 12.4229 31.2166 12.4054 31.1906C12.3878 31.1646 14.8505 29.5062 17.9068 27.4863C20.9632 25.4664 23.4433 23.8513 23.4718 23.8773Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.5042 21.634C32.5217 21.66 28.4246 24.3965 23.3548 27.7479C18.2849 31.0993 14.1528 33.7947 14.1397 33.7709C14.1265 33.7471 18.2148 31.0062 23.2912 27.6548C28.3677 24.3034 32.4866 21.608 32.5042 21.634Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.3098 24.3098C34.3273 24.3357 30.2303 27.0744 25.1604 30.4258C20.0906 33.7772 15.9585 36.4727 15.9453 36.4467C15.9322 36.4207 20.0249 33.6841 25.0969 30.3306C30.1689 26.977 34.2923 24.2838 34.3098 24.3098Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.1277 26.9885C36.1452 27.0144 32.0482 29.7532 26.9783 33.1024C21.9085 36.4516 17.7764 39.1514 17.7764 39.1254C17.7764 39.0994 21.8537 36.3607 26.9257 33.0093C31.9978 29.6579 36.1102 26.9625 36.1277 26.9885Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.9297 29.6672C37.9472 29.6932 33.8502 32.4297 28.7803 35.7811C23.7105 39.1325 19.5784 41.8279 19.5674 41.8019C19.5565 41.776 23.6513 39.0394 28.7277 35.688C33.8041 32.3366 37.9297 29.6412 37.9297 29.6672Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M111.565 34.9664L90.9199 48.6133L111.255 78.6522L131.9 65.0053L111.565 34.9664Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M121.225 63.5883L120.99 65.0215L110.726 63.5602L110.962 62.127L121.225 63.5883Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M116.063 58.4795L117.535 58.6895L115.903 68.6744L114.429 68.4644L116.063 58.4795Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M106.608 45.7976C106.625 45.8236 104.559 47.22 101.991 48.9152C99.4237 50.6104 97.3292 51.9656 97.3116 51.9462C97.2941 51.9267 99.3623 50.5259 101.928 48.8286C104.494 47.1312 106.59 45.7608 106.608 45.7976Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M114.198 43.9035C114.216 43.9295 110.778 46.2331 106.53 49.0454C102.282 51.8577 98.8047 54.1223 98.7872 54.0963C98.7696 54.0703 102.207 51.7668 106.455 48.9523C110.704 46.1378 114.174 43.8776 114.198 43.9035Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M115.723 46.1516C115.74 46.1775 112.303 48.4811 108.054 51.2956C103.806 54.11 100.329 56.3703 100.312 56.3443C100.294 56.3183 103.721 54.0256 107.98 51.2111C112.239 48.3966 115.71 46.1277 115.723 46.1516Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M117.24 48.3947C117.258 48.4207 113.818 50.7242 109.572 53.5387C105.326 56.3532 101.847 58.6134 101.829 58.5874C101.812 58.5615 105.249 56.2601 109.497 53.4434C113.746 50.6268 117.225 48.373 117.24 48.3947Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M118.778 50.6516C118.796 50.6776 115.358 52.979 111.11 55.7934C106.862 58.6079 103.385 60.8682 103.367 60.8443C103.35 60.8205 106.787 58.5148 111.036 55.7003C115.284 52.8859 118.75 50.6256 118.778 50.6516Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M78.8978 12.3139L56.3711 0.408203L38.6302 33.1852L61.157 45.0909L78.8978 12.3139Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M57.3038 34.8371L55.8753 35.3199L52.2471 25.4107L53.6778 24.9258L57.3038 34.8371Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M59.4922 27.7256L60.0137 29.148L50.0537 32.5189L49.5322 31.0965L59.4922 27.7256Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M66.5687 13.1061C66.5512 13.1385 64.2682 11.9651 61.466 10.4864C58.6638 9.00775 56.4093 7.7802 56.4269 7.74773C56.4444 7.71525 58.7295 8.88868 61.5318 10.3674C64.334 11.846 66.5863 13.0714 66.5687 13.1061Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M71.973 19.0016C71.9555 19.0341 68.1739 17.0683 63.5269 14.6132C58.8799 12.1581 55.129 10.1403 55.1465 10.1078C55.1641 10.0753 58.9435 12.039 63.5904 14.4962C68.2374 16.9535 71.9905 18.9691 71.973 19.0016Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M70.6527 21.4567C70.6351 21.4891 66.8536 19.5255 62.2066 17.0682C57.5596 14.611 53.8087 12.5954 53.8262 12.5629C53.8438 12.5304 57.6231 14.4962 62.2701 16.9513C66.9171 19.4064 70.6702 21.4242 70.6527 21.4567Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M69.3236 23.9078C69.306 23.9403 65.5245 21.9766 60.8775 19.5215C56.2305 17.0664 52.4796 15.0552 52.4971 15.0162C52.5147 14.9772 56.294 16.9474 60.941 19.4025C65.588 21.8575 69.3411 23.8753 69.3236 23.9078Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M67.9915 26.3627C67.974 26.3952 64.1925 24.4315 59.5455 21.9764C54.8985 19.5213 51.1454 17.5036 51.1651 17.4711C51.1848 17.4386 54.962 19.4023 59.609 21.8574C64.256 24.3125 68.0091 26.3302 67.9915 26.3627Z",
    fill: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M126.591 79.7536C126.591 79.7839 98.2735 79.8098 63.3477 79.8098C28.4219 79.8098 0.0996094 79.7904 0.0996094 79.7536C0.0996094 79.7167 28.4131 79.6973 63.3477 79.6973C98.2822 79.6973 126.591 79.7211 126.591 79.7536Z",
    fill: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6952 35.3063L38.9393 74.6657L37.9315 79.8184L89.6377 79.5716C91.9601 79.5608 94.0196 77.5235 94.7623 74.4969L103.934 37.3392C104.501 35.0421 103.257 32.652 101.495 32.6542L49.1491 32.7083C48.0098 32.7061 46.9888 33.7713 46.6952 35.3063Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6952 35.3063L38.9393 74.6657L37.9315 79.8184L89.6377 79.5716C91.9601 79.5608 94.0196 77.5235 94.7623 74.4969L103.934 37.3392C104.501 35.0421 103.257 32.652 101.495 32.6542L49.1491 32.7083C48.0098 32.7061 46.9888 33.7713 46.6952 35.3063Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6861 71.9956L79.2088 28.3906C78.9897 26.6045 77.5459 25.2709 75.8435 25.2774L63.8372 25.3142C63.391 25.3191 62.9505 25.4138 62.5425 25.5925C62.1346 25.7712 61.7677 26.03 61.4644 26.3534L55.7679 32.3439L22.378 32.5214C20.3382 32.5322 18.7695 34.4418 19.039 36.5851L24.1242 76.8863C24.3433 78.6703 25.7871 80.0017 27.4851 79.9996L85.6874 79.8848C92.1682 80.0169 92.7882 78.1269 92.7882 78.1269C85.3478 79.7528 84.6861 72.0064 84.6861 71.9956Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5827 63.2731L57.6196 65.3558L42.5021 51.9156L44.4652 49.8328L59.5827 63.2731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8036 49.3705L58.9726 51.2995L45.2945 65.8157L43.1233 63.8867L56.8036 49.3705Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.9554cf6b44bb5a768c0a6853da21c968.svg";
export { ForwardRef as ReactComponent };